import { createAsyncSelectors } from '@lib/selectors';
import { useAction } from '../useAction';
import { useAsyncState } from '../useAsyncState';
import { coreActions } from '@sonar-software/sonar-core';
const selectors = createAsyncSelectors((state) => state.core.stakeholders.post);
export function useAddStakeholder() {
    const { data, isIdle, isReceived, isRequested } = useAsyncState(selectors);
    const request = useAction(coreActions.requestPostCoreStakeholders);
    const reset = useAction(coreActions.resetPostCoreStakeholders);
    return {
        isIdle,
        isReceived,
        isRequested,
        request,
        reset,
        response: data
    };
}
useAddStakeholder.selectors = selectors;
